export default {
  navBar: {
    manageBusinessAccount: ' Manage Business Account',
    portal: 'Cardinal Cloud',
    profileIcon: {
      manageYourAccount: 'Manage Your Account',
      logOut: 'Logout',
      textNoPermission: 'Sorry, you do not have permission to access this page'
    },
    allMyLocations: 'All my locations',
    userLocationsTooltip: 'User locations',
    globalSearchTooltip: 'Global Search',
    serverAccessTooltip: 'Server Access',
    inboxTooltip: 'Inbox',
    profileTooltip: 'Profile',
    viewMyNotes: 'View My Notes'
  },
  common: {
    email: 'Email',
    firstName: 'First Name',
    lastName: 'Last Name',
    password: 'Password',
    edit: 'Edit',
    active: 'ACTIVE',
    pending: 'PENDING',
    unassigned: 'Unassigned',
    noData: 'No data',
    filters: 'Filters',
    severity: 'Severity',
    ssid: 'SSID',
    optional: 'Optional',
    enabled: 'Enabled',
    lastUpdated: 'Last Updated',
    results: 'Results',
    noResultsFound: 'No results found',
    copiedText: 'Copied text!',
    errorCopyText: 'Error copying text!',
    copyText: 'Copy Text',
    previous: 'Previous',
    next: 'Next',
    select: 'Select',
    no: 'No',
    yes: 'Yes',
    ok: 'ok',
    up: 'Up',
    down: 'Down',
    view: 'View',
    update: 'Update',
    cancel: 'Cancel',
    save: 'Save',
    add: 'Add',
    loading: 'Loading...',
    delete: 'Delete',
    send: 'Send',
    viewMore: 'View More',
    details: 'Details',
    and: ' and ',
    authorize: 'Authorize',
    unauthorize: 'Unauthorize',
    thisActionIsIrreversible: `This actions is irreversible`,
    somethingWentWrong: 'Something went wrong',
    assignLater: 'Assign later',
    missingInformation: 'Missing information',
    noSystemPermissions: 'No system permissions',
    fieldNoSpaces:
      'The field must contain at least one letter and cannot be just spaces.',
    noFileSelected: 'Click to upload file',
    payload: 'Payload',
    response: 'Response',
    notFound: 'Not found',
    reOrder: 'Reorder',
    typeToSearch: 'Search',
    globalSearch: 'Global Search',
    readMore: 'Read more',
    readLess: 'Read less',
    openDetails: 'Open Details',
    phoneNumber: 'Phone Number',
    enterAPhoneNumber: 'Enter a phone number',
    enterAName: 'Enter a name',
    enterAnAddress: 'Enter an address',
    enterAZipCode: 'Enter a zip code',
    enterAState: 'Enter a state',
    enterAWebsiteAddress: 'Enter a website address',
    latitude: 'Latitude',
    longitude: 'Longitude',
    enterALatitude: 'Enter a latitude',
    enterALongitude: 'Enter a longitude',
    accountingEmail: 'Accounting Email',
    enterAnAccountingEmail: 'Enter an accounting email',
    domainName: 'Domain Name',
    enterADomainName: 'Enter a domain name',
    specialInstructions: 'Special Instructions',
    enterSpecialInstructions: 'Enter special instructions',
    ownerEmail: 'Owner Email',
    primaryContactUserEmail: 'Primary Contact User Email',
    remove: 'Remove',
    reloadPage: 'Reload Page',
    removeFilters: 'Remove Filters'
  },
  globalSearch: {
    goToLocation: 'Go to location',
    goToUserDetails: 'Go to user details',
    goToOrganization: 'Go to organization',
    goToDevice: 'Go to device',
    goToDeviceLocation: 'Go to location devices',
    openInExternalTab: 'Open in external tab',
    assignedLocation: 'Assigned location',
    sendEmail: 'Send message',
    goToDefaultLocation: 'Go to default location'
  },
  formCommons: {
    fieldRequired: 'This field is required',
    invalidText: 'Invalid text'
  },
  login: {
    alreadyHaveAccount: 'Already have account?',
    noGetEmail: "Didn't get a email?",
    resendEmail: 'Resend email',
    agreeTermsLabel: 'By creating this account, you agree to ',
    successPostData: 'The account was created successfully.',
    redirectToLoginPage: 'You will be redirected to login page in',
    termsOfServiceLabel: 'Terms of Service',
    privacyPolicyLabel: 'Privacy Policy',
    callBack: '/callback',
    userRegistration: '/user-registration',
    createUser: '/create-user',
    loginWithPassword: '/login-with-password',
    resetPassword: '/reset-password',
    loginWith: 'Login with',
    passwordless: 'Passwordless',
    passwordlessSMS: 'Passwordless (SMS)',
    backToLogin: 'Back to login',
    nickname: 'Nickname',
    email: 'Email',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    forgotPass: 'Forgot Password?',
    signIn: 'Sign in',
    signUp: 'Sign up',
    createAccount: 'Create Account',
    haveAnAccount: 'Already have an account?',
    logIn: 'Log in',
    changePasswordTitle: 'Change Password',
    changePasswordButton: 'Send me an email',
    noAccount: "Don't have an account?",
    forgotPasswordAsk: 'Forgot Password?',
    createOne: 'Create one.',
    userNameIsRequired: 'Username is required',
    userNameMustBeValid: 'Username must be valid',
    passwordMustMatch: 'Passwords must match',
    emailIsRequired: 'Email is required',
    emailMustBeValid: 'Email must be a valid email format',
    passwordIsRequired: 'Password is required',
    passwordMinCharacters: 'Password must be at least 4 characters',
    passwordStrong:
      'Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character',
    maxAllowedCharacters: 'This field must not be longer than 50 characters',
    emailValidation:
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/,
    forgotPassword: 'Forgot Password',
    forgotPasswordText:
      'Enter your email address associated with your account, and we will send you an email with the steps to follow to reset your password.',
    resetPasswordTitle: 'Reset Password',
    forgotSuccess:
      'An email has been sent to reset your password. Now you can close this tab.',
    resetPasswordSuccess: 'Password reset successfully'
  },
  serverAccess: {
    haven: 'MedicalCart',
    pageTitle: 'Server Access',
    menu: {
      serviceHealth: 'Services:Health',
      organizations: 'Organizations',
      versions: 'Versions',
      productsModels: 'Products/Models',
      users: 'Users',
      locations: 'Locations',
      devices: 'Devices',
      deviceAnnounce: 'Device Announce',
      globalDeviceAnnounce: 'Global Device Announce',
      customVersions: 'Custom Versions'
    },
    folder: { successAddFolder: 'Successfully added Folder' },
    scheduleFirmwareUpdate: {
      scheduleFirmwareUpdate: 'Schedule Firmware Update',
      firmwareOTA: 'Firmware OTA',
      deleteFirmwareTitle: 'Do you want to delete this firmware schedule?',
      successDeleteFirmware: 'Firmware schedule deleted successfully',
      deleteFirmware: 'Delete firmware schedule',
      deleteSuccess: 'Firmware schedule deleted successfully'
    },
    devices: {
      deleteCredentials: 'Delete Credentials',
      fileListLabel: 'File List',
      setWifiCredentialsLabel: 'Set Wifi Credentials',
      rebootDevicesLabel: 'Reboot Devices',
      successRebootDevice: 'Device(s) rebooted successfully',
      addDeviceToLocationLabel: 'Add Device to Location',
      deletedMethod: 'Method Deleted!',
      debugDeviceLabel: 'Debug',
      getDebugDeviceLabel: 'Get debug',
      successDebug: 'Debug Sent Successfully',
      successEditMethod: 'Successfully Edit Method',
      renegerateCredentials: 'Credentials Recreated Successfully',
      addDevice: 'Add Device',
      editDevice: 'Edit Device',
      editMultipleDevices: 'Multiple Devices',
      successPostCustomFile: 'Custom file sent successfully',
      macAddress: 'Mac Address',
      successAddDevice: 'Successfully added device',
      successSendDeviceAnnounce: 'Sent device announce successfully',
      successDeletedDevice: 'Successfully deleted device',
      methodsInformation: 'Methods Information',
      methodsButtonLabel: 'Methods',
      scheduleMethods: 'Schedule Methods',
      records: 'Records',
      singletonMethodLabel: 'Singleton Methods',
      staticMethodLabel: 'Static Methods',
      systemMethodLabel: 'System Methods',
      staticLabel: 'Static',
      singletonLabel: 'Singleton',
      addMethodLabel: 'Add Method',
      getCredentials: 'Get Credentials',
      getDebugDevice: 'Get Debug Info',
      getMethodsTitle: 'Get Methods',
      renewCredentials: 'Renew',
      credentialsLabel: 'Credentials',
      getDeviceAnnounce: 'Device Announce',
      currentDevice: 'Current Device:',
      file: 'File',
      methodAcknowledgementLabel: 'Acknowledge',
      deleteDeviceTitle: 'Do you want to delete this device?',
      deleteDeviceFromLocationTitle:
        'Do you want to delete this device from location?',
      deleteMethodTitle: 'Do you want to delete this method?',
      deleteDeviceText: `This action is irreversible. Please note this device will have to be added as an Authorized device again`,
      deleteDeviceFromLocation:
        'This action would remove the device from the location',
      methodNameLabel: 'Method name',
      methodValueLabel: 'Method value',
      sendDebugLabel: 'Send debug',
      sendDeviceAnnounceLabel: 'Send Device Announce',
      dataLabel: 'Data',
      hardwareVersionLabel: 'Hardware Version',
      uniqueProductNameLabel: 'Unique Product Name',
      firmwareVersionLabel: 'Firmware Version',
      ackRequired: 'Acknowledge required',
      customFiles: 'Custom Files',
      toggleSyncLabel: 'Toggle Sync Status',
      successDeleteCredentials: 'Credentials deleted successfully'
    }
  },
  locations: {
    confirmShareBusinessAccounts:
      'This will share your location with all the users belonging to that business account. ',
    confirmShareDomain:
      'This will share your location with all the users belonging to that domain. ',
    shareLocationSuccess: 'Successfully shared locations',
    shareLocationHint:
      'For example: example@example.com for email, #example for business account or @example.com.mx for domain',
    targets: 'Targets',
    areYouSureToShareWithDomain: 'Are you sure to share with domain?',
    areYouSureToShareWithBusinessAccount:
      'Are you sure to share with business account?',
    locations: 'Locations',
    goToLocation: 'Go to location',
    areYouSureToShare: 'Are you sure to share?',
    shareLocationsWithTargets: 'Share Locations With Targets',
    confirmShareLoc:
      'This will share your location/organization with all the users belonging to that business account. ',
    searchByNameOwnerAddress: 'Search by Name, Owner, Address',
    selectExistingLocation: 'Select Existing Location',
    moveToOrg: 'Move to Organization',
    systemRole: 'System Role',
    successTransferLocation: 'Successfully Transferer Location',
    email: 'Account Email',
    owner: 'Owner',
    apiKey: 'API Key',
    locationName: 'Location Name',
    enableBitfield: 'Enable Bitfield',
    shareLocationPlaceholder: 'example@example.com or #example...',
    shareLocation: 'Add User to Location',
    shareLocationLabel: 'Enter an email address or business account.',
    transferOwnership: 'Transfer Ownership',
    allLocations: 'All Locations',
    assignLocation: 'Assign Location',
    successAssignedLocation: 'Successfully Assigned Location',
    successAddedLocations: 'Successfully Added Location',
    successDeleteLocations: 'Successfully Deleted Location',
    assignLocationTitle: 'Add Location to Folder',
    assignOrganizationTitle: 'Add Location to Organization',
    locationsToAssign: 'Locations To Assign',
    locationsAssigned: 'Assigned Locations',
    addLocation: 'Add Location/Organization',
    successAddLocation: 'Successfully added Location',
    successEditLocation: 'Successfully Edit Location',
    nameLocation: 'Location Name',
    addLocationAsOrg: 'Add Location as a organization',
    orgText:
      'An Organization is used to manage and control one ore more locations.',
    title: 'Locations',
    online: 'Online',
    upToDate: 'Up to Date',
    addFolder: 'Add Folder',
    folder: 'Name Folder',
    shared: 'Shared',
    locationId: 'Location Id',
    locationAlias: 'Location Alias',
    successShareLoc: 'Successfully Share Location',
    addUserToLocation: {
      addUserTitle: 'Add user to location',
      deleteUser: 'Do you want to delete this user from this location?'
    },
    deleteLocation: 'Delete location',
    deleteLocationTitle: 'Do you want to delete this location permanently?',
    successDeleteLocation: 'Successfully deleted the location',
    noLocationAssigned: 'No location assigned'
  },
  organizations: {
    organization: 'Organization',
    successShareOrg: 'Successfully Share Organization',
    successTransferOrg: 'Successfully Transferer Organization',
    organizationName: 'Organization Name',
    shareOrg: 'Share Organization',
    successDeletedOrganization: 'Successfully Deleted Organization',
    successAddOrganization: 'Successfully added Organization',
    organizations: 'Organization',
    removeAll: 'Remove All',
    Change: 'Change',
    addOrganization: 'Add Organization',
    nameOrganization: 'Name Organization',
    enterNameOrganization: 'Enter name of organization',
    deleteOrganization: 'Delete organization',
    deleteOrganizationTitle:
      'Do you want to delete this organization permanently?',
    successDeleteOrganization: 'Successfully deleted the organization',
    viewLocationsAssigned: 'View assigned locations'
  },
  userProfile: {
    deleteAccount: 'Delete my account',
    deleteAccountConfirmation: 'Are you sure you want to delete your account?',
    deleteAccountTitle: 'Delete my account',
    authorizationStatus: 'Authorization Status',
    editUser: 'Edit User',
    manageProfile: 'Manage Profile',
    successEdited: 'User edited successfully',
    successDelete: 'User deleted successfully',
    title: 'User Information',
    fillAllTheInformation:
      'Please fill out all the information to finish creating your account.',
    editAccount: 'Edit your Account',
    emailLabel: 'Email Address',
    updateInfoBtn: 'Update info',
    deleteUserLabel: 'Delete user',
    remindMeLaterBtn: 'Remind me later',
    firstNameLabel: 'First name',
    lastNameLabel: 'Last name',
    fullNameLabel: 'Full name',
    nicknameLabel: 'Nickname',
    passwordLabel: 'Password',
    statusLabel: 'Status',
    mobileNumberLabel: 'Mobile number',
    mobileNumberLabelDisclaim: '(for account security verification)',
    mobileNumberError: 'Enter a valid phone number',
    successCreateProfile: 'The account was created successfully',
    editAccountButton: 'Edit Account',
    createAccount: 'Create Account',
    checkEmailForValidation: 'Check your email for validation link',
    successToggleStatus: 'Successfully toggled status',
    changePassword: 'Change Password',
    currentPassword: 'Current Password',
    newPassword: 'New Password',
    confirmPassword: 'Confirm Password',
    successPasswordChanged: 'Password changed successfully'
  },
  users: {
    successActivateUser: 'User activated successfully',
    successDeleteUser: 'User deleted successfully',
    activateUser: 'Activate User',
    activationUsers: 'Activation Users',
    successAuthorizeApp: 'Application authorized successfully',
    errorAuthorizeApp: 'Error authorizing application',
    successDeleteAuthorizedApp: 'Application unauthorized successfully',
    errorDeleteAuthorizedApp: 'Error unauthorizing application',
    manageAuthorizedApps: 'Manage Authorized Apps',
    authorizedApps: 'Authorized Apps',
    unverifiedEmailAccounts: 'Unverified Email Accounts',
    pendingUsers: 'Pending Users',
    usersDeletedSuccessfully: 'Users deleted successfully',
    filterByAuthorized: 'Filter by authorized',
    userNotFound: 'User not found',
    users: 'Users',
    active: 'Active',
    pending: 'Pending',
    successChangeRole: 'Change role successfully',
    addUser: 'Add user',
    successCreateUser: 'User created successfully',
    createNewUser: 'Create new user with role',
    notPermission: '/user-not-permission',
    deleteAccountSteps: '/delete-account-steps',
    authorized: 'Authorized',
    unAuthorized: 'Unauthorized',
    userUnauthorized: 'User unauthorized',
    loginSuccess: 'Login Success',
    authorize: 'Authorize',
    unauthorize: 'Unauthorize',
    deleteUsers: 'Delete users',
    deleteUsersTitle: 'Are you sure want to delete these users?',
    successDeleteUsers: 'Users deleted successfully',
    deleteUserTitle: 'Are you sure want to delete this user?',
    userDetails: 'User Details',
    systemRole: 'System Role',
    serverAccess: 'Server Access',
    filterByTextLabel: 'Filter',
    filterByOwnerLabel: 'Filter by Owner',
    filterBySharedWithLabel: 'Filter by Shared With',
    accountLoginCode: 'Account Login Codes'
  },
  versions: {
    productId: 'Product Type',
    targetLocation: 'Target Location',
    targetDevice: 'Target Device',
    versions: 'Versions',
    confirmDeleteVersion: 'Do you want to delete this version?',
    successDeleteVersion: 'Version deleted successfully',
    deleteVersion: 'Delete version',
    addVersion: 'Add Version',
    uploadedFiles: 'Uploaded Files',
    activate: 'Activate',
    deactivate: 'Deactivate',
    promoteToProduction: 'Promote to Production',
    versionName: 'Version Name',
    wifiModuleVersion: 'Wifi module version name',
    fileUrl: 'File Uploaded Url',
    customUrl: 'Custom URL',
    otaFile: 'Wifi module OTA file',
    successAddFirmwareVersion: 'Firmware version added successfully',
    successEditFirmwareVersion: 'Firmware version edited successfully',
    statusChanged: 'Status changed successfully',
    uploadFile: 'Upload File',
    upgradeType: 'Upgrade Type',
    controllerType: 'Controller Type',
    successDeleteUploadedFiles: 'Uploaded files deleted successfully',
    deleteFiles: 'Delete file(s)',
    confirmDeleteFiles: 'Do you want to delete these file(s)?',
    filterByTarget: 'Filter by Target'
  },
  manageRoles: {
    manageRoles: 'Manage Roles',
    addRole: 'Add New Role',
    addRoleTitle: 'Add Role',
    name: 'Name',
    addAdmin: 'Add Admin',
    accountEmail: 'Account Email',
    role: 'Role',
    usePredefineRole: 'Use a pre-defined role',
    successAddNewRole: 'Added new rol successfully'
  },
  applications: {
    transferLoc:
      'Transfer ownership of this location to another administrator.',
    occurs: 'Occurs',
    at: 'at',
    automaticUpdates: 'Automatic Updates',
    bitField: 'Bitfield',
    auditLog: 'Audit Log',
    enableAuditLog: 'Enable Audit Log',
    sunriseTime: 'Sunrise Time',
    sunsetTime: 'Sunset Time',
    localTime: 'Local Time',
    longitude: 'Longitude',
    latitude: 'Latitude',
    streetAddress: 'Street Address',
    currentOwner: 'Current Owner',
    consoleControls: 'Console Controls',
    showMoreDetails: 'Show more Details',
    pageTitle: 'Applications',
    menu: {
      sb600: 'SB 600'
    }
  },
  devices: {
    deleteCredentials: 'Delete Credentials',
    successDeleteCredentials: 'Credentials deleted successfully',
    status: 'Status',
    version: 'Version',
    model: 'Model',
    lastAnnounceInfo: 'Last Announce Info',
    addMethod: 'Add Method',
    deleteMethods: 'Delete methods',
    deleteMethodsTitle: 'Are you sure want to delete these methods?',
    dbDeleteTitle: 'Do you want to delete this database?',
    methodDeleteTitle: 'Do you want to delete this method?',
    productType: 'Product Type',
    methodType: 'Method Type',
    deviceId: 'Device Id',
    devices: 'Devices',
    addDeviceToLocationTitle: 'Add device(s) to location',
    addToLocation: 'Add to location',
    deleteDeviceSuccess: 'Device deleted successfully',
    singletonSentSuccess: 'Singleton method sent successfully',
    staticSentSuccess: 'Static method sent successfully',
    enterDeviceId: 'Enter device id',
    successDeleteMethods: 'Methods deleted successfully',
    ssidLabel: 'SSID',
    ssidPlaceholder: 'Enter SSID',
    passwordLabel: 'Password',
    passwordPlaceholder: 'Enter Password',
    setWifiCredential: 'Set Wifi Credential',
    sendFileThroughEmailTitle: 'Send file to email',
    sendFiles: 'Send Files',
    emailToMe: 'Email to me',
    emailSentSuccess: 'Email sent successfully',
    deleteAssignedLocation: 'Delete assigned location',
    synced: 'Synced',
    notSynced: 'Not Synced',
    allSynced: 'All synced',
    na: 'No info'
  },
  myFiles: { myFiles: 'My Files' },
  businessAccount: {
    createUserAndAssign: 'Create User and Assign',
    deleteBusinessAccount: 'Delete Business Account',
    leave: 'Leave Business Account',
    phone: 'Phone',
    address: 'Address',
    owner: 'Owner',
    totalMembers: 'Total Members',
    viewMembers: 'View Members',
    addMember: 'Enter email to invite member',
    businessAccountName: 'Corporate Name',
    businessAccount: 'Business Account',
    businessAccountUsers: 'Business Account users',
    addUsersToBusinessAccount: 'Add Users To Business Account',
    usersToAssign: 'Users To Assign',
    assignedUsers: 'Assigned Users',
    successAddedUser: 'Successfully Added User',
    successBusiness: 'Added Business Account Successfully',
    successEditBusiness: 'Edited Business Account Successfully',
    successDeleteUser: 'Successfully Deleted User',
    deleteBusiness: 'Do you want to delete this Business Account?',
    leaveBusiness: 'Do you want to leave this Business Account?',
    removeFromBusiness: 'Remove from Business Account',
    removeFromBusinessTitle:
      'Do you want to remove this location(s) from this Business Account?',
    successDeleteAccount: 'Successfully Deleted Business Account',
    createBusinessAccount: 'Create Business Account',
    successLeavedAccount: 'Successfully Left Business Account',
    enterABusinessAccountPhone: 'Enter a business account phone',
    deleteUserTitle: 'Do you want to delete this user(s)?',
    removeUser: 'Remove user',
    businessAccountAddress: 'Address',
    enterAnAddress: 'Enter an address',
    businessAccountPhoneNumber: 'Business Account Phone',
    businessAccountZipCode: 'Zip Code',
    businessAccountState: 'State',
    businessAccountWebsiteAddress: 'Business Account Website Address',
    websiteAddress: 'Website Address',
    editBusinessAccount: 'Edit Business Account',
    primaryContactEmail: 'Primary Contact Email',
    userNotExist: 'User does not exist',
    createUser: 'Do you want to create this user?',
    anEmailWasSentToNewUser: 'An email was sent to the user'
  },
  notes: {
    addNote: 'Add Note',
    createNote: 'Create Note',
    successNote: 'Note created successfully',
    successEditNote: 'Note edited successfully',
    myNotes: 'My Notes',
    deleteNote: 'Do you want to delete this note?',
    successDeleteNote: 'Note deleted successfully',
    deleteNoteTitle: 'Delete Note',
    viewNote: 'View Note',
    editNote: 'Edit Note',
    changeSeverityLevel: 'Change Severity Level'
  },
  dashboard: {
    followUp: 'Follow up',
    myActivity: 'My Activity',
    customerActivityFeed: 'Customer Activity Feed',
    newAlerts: 'New Alerts',
    flaggedLocations: 'Flagged Locations',
    watchList: 'Watch list',
    totalControllers: 'Total Controllers'
  },
  manufacture: {
    partNumber: {
      title: 'Part Number',
      create: {
        partNumber: 'Part Number',
        series: 'Series',
        product: 'Product',
        model: 'Model',
        sku: 'SKU',
        startSerialNumber: 'Start Serial Number',
        description: 'Description',
        deleteUserTitle: 'Are you sure want to delete this part?',
        deletePartLabel: 'Delete Part Number'
      }
    },
    serialNumber: {
      title: 'Serial Number',
      create: {
        quantity: 'Quantity',
        soNumber: 'SO Number',
        deleteSerialLabel: 'Delete Serial Number'
      }
    },
    shippingOrder: {
      title: 'Shipping Order',
      addShippingOrder: 'Add Shipping Order',
      deleteShippingOrderTitle:
        'Are you sure want to delete this shipping order?',
      deleteSippingOrderLabel: 'Delete Shipping Order'
    }
  }
};
